import {Injectable} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {switchMap} from 'rxjs';
import * as fromGql from './system-user-role.graphql';
import {SystemUserRole} from './system-user-role.model';
import {BaseResponse} from "../../../../../common/interfaces/global-interfaces";
import {GraphqlService} from "../../../../../services/graphql.service";
import {SystemUserRoleActions} from "./system-user-role.actions";

@Injectable()
export class SystemUserRoleEffects {

  loadData$ = createEffect(() => this.actions$.pipe(
    ofType(SystemUserRoleActions.getAllRoles),
    switchMap((action) => this.apollo.queryObservable({
      query: fromGql.GET_ALL_SYSTEM_USER_ROLES,
        variables: {
          uniqueId: action.filter?.uniqueId,
        }
      })
    ),
    switchMap((response: any) => {
      const result: BaseResponse<SystemUserRole[]> = Object.values(Object.values(response)[0])[0];
      return [
        SystemUserRoleActions.loadSystemUserRoles({systemUserRoles: result?.data || []}),
        SystemUserRoleActions.rolesLoadingState({loading: false})
      ]
    })
  ));

  constructor(
    private actions$: Actions,
    private apollo: GraphqlService,
  ) {
  }
}
